export default __webpack_public_path__ + "static/media/signpost-2.4e850102.png";